var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"70vh","overflow-y":"auto","overflow-x":"none"}},[(!_vm.schema)?_c('div',[_vm._v(" Une erreur est survenue. ")]):_c('div',[_c('item-form-fields',{attrs:{"fields":_vm.schema.fields,"form-data":_vm.formData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }